import { forwardRef } from 'react';
import styles from './Button.module.scss';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  prefixIcon?: React.ReactNode;
  postfixIcon?: React.ReactNode;
  icon?: React.ReactNode;
  iconSpacing?: number;
  variant?: 'primary' | 'secondary' | 'light' | 'outlined' | 'transparent';
  contentVariant?: 'regular' | 'icon';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      prefixIcon,
      postfixIcon,
      icon,
      iconSpacing = 10,
      variant = 'primary',
      contentVariant = 'regular',
      className = '',
      disabled,
      ...props
    },
    ref,
  ) => {
    return (
      <button
        className={`${className} ${styles.Button} ${styles[variant]} ${styles[contentVariant]} ${
          disabled ? styles.disabled : ''
        }`}
        disabled={disabled}
        {...props}
        ref={ref}
      >
        <>
          {prefixIcon && (
            <span className={`${styles.Icon} ${styles.prefix}`} style={{ marginRight: iconSpacing + 'px' }}>
              {prefixIcon}
            </span>
          )}
          {icon && <span className={`${styles.Icon} ${disabled ? styles.disabled : ''}`}>{icon}</span>}
          {children}
          {postfixIcon && (
            <span className={styles.Icon + ' ' + styles.postfix} style={{ marginLeft: iconSpacing + 'px' }}>
              {postfixIcon}
            </span>
          )}
        </>
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
